import styled from "styled-components";
import { BaseGridContainer } from "../../../utils/styles";

export const Container = styled(BaseGridContainer)`
	width: 100%;
	position: relative;
	box-sizing: border-box;
	img {
		display: block;
	}
`;

export const Expired = styled.div`
	box-sizing: border-box;
	width: 100%;
	padding: 0.875rem 0;
	text-align: center;
	background: #333;
	opacity: 0.85;
	font-size: 0.9375rem;
	font-weight: 500;
	color: #fff;
`;

export const Content = styled.section`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	font-size: 0.9375rem;

	& > h1 {
		color: #fff;
		font-family: var(--fontMedium);
		font-weight: 500;
		line-height: 1.125rem;
		text-align: center;
	}

	& > div {
		display: flex;
		font-family: var(--fontBold);
		font-weight: 600;
		line-height: 2.25rem;
		margin-top: 0.5rem;

		> div:last-child {
			margin-right: 0;
		}
	}
`;

export const Num = styled.span`
	width: 1.75rem;
	height: 2.25rem;
	text-align: center;
	color: #333;
	background-color: #fff;
	box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
	border-radius: 2px;
	margin-right: 0.375rem;

	/* &:not(:first-child) {
		margin-left: 9px;
	} */
`;

export const BoxSymbol = styled.span`
	color: #fff;
	margin: 0 0.5rem 0 0.125rem;
`;
